import React, { useEffect, useState } from "react";
import NextImage from "./NextImage";
import { buildTabsList, getClassForResult, getImageId, getImageUrl, getTabsData, titleToSlug } from "../../utils/generalLiveCenter";
import Tabs from "./football/Tabs";

const LeagMainHead = ({
  headData,
  countary,
  children,
  dataClient,
  currentTab,
  websiteBaseUrl,
  dataPath,
  id,
  widgetTitle,
  state = "league",
  sport = "football",
}) => {
  const [clientHeadData, setClientHeadData] = useState(null);
  const baseURL =
    process.env.REACT_APP_BASE_URL ||
    "https://ipublisher-microservices.6lgx.com";

  useEffect(() => {
    if (!dataClient) return;
    const container = document.querySelector(".microservice-cont");
    const dataAttr = container?.getAttribute("data-listingdata");

    if (dataAttr) {
      try {
        const parsed = sport === 'golf' && state === 'player' ? JSON.parse(dataAttr)?.data : JSON.parse(dataAttr)?.headData;
        setClientHeadData(parsed);
      } catch (error) {
        console.error("Failed to parse headData:", error);
      }
    }
  }, [dataClient]);


  const sourceData = dataClient ? clientHeadData?.data : headData?.data;

  const tabsData = getTabsData(dataClient, clientHeadData, headData, sourceData, sport, state) || [];
  const imgId = getImageId(state, sport, sourceData);
  const imgUrl = getImageUrl(baseURL, state, sport, imgId);
  const title = sourceData?.nm || sourceData?.name;
  const manager = sourceData?.mang;



  return (
    <>
      <div className="leag_head2">
        {widgetTitle && <h1>{widgetTitle}</h1>}
        <div className="leag_main_head">
          <div className="up_head">
            <div className="up_wrap">
              <div className="icon_flag">
                <NextImage
                  src={imgUrl}
                  width={60}
                  height={60}
                  alt="leag"
                  priority
                />
              </div>
              <div className="info_wrap">
                <span className="a">
                  <strong className="name">{title}</strong>
                  {countary && <span className="country_name">{countary}</span>}
                </span>
                {state === "team" && (
                  <ul className="result_list">
                    {sourceData?.form?.map((result, index) => (
                      <li key={index} className={getClassForResult(result)}>
                        {result}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <span className="more cursor_pointer" />
          </div>

          {manager && (
            <div className="venue_wrap">
              <ul>
                <li>
                  <span className="lb">Manager :</span> {manager}
                </li>
              </ul>
            </div>
          )}

          {state === "player" && sport === 'football' && (manager?.dob !== null || manager?.height || manager?.weight) && sourceData && (
            <div className="venue_wrap">
              <ul>
                {sourceData?.dob && (
                  <li>
                    <span className="lb">{"Date of Birth:"} :</span>
                    {sourceData?.dob}
                  </li>
                )}
                {sourceData?.height && (
                  <li>
                    <span className="lb">{"Height:"} :</span>
                    {`${sourceData?.height} cm`}
                  </li>
                )}
                {sourceData?.weight && (
                  <li>
                    <span className="lb">{"Weight:"} :</span>
                    {`${sourceData?.weight} kg`}
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>

        {dataClient && (
          <Tabs
            clas="main_tab2"
            data={buildTabsList(sport, state, tabsData)}
            sport={sport}
            name={titleToSlug(title)}
            id={id}
            state={state}
            currentTab={currentTab}
            websiteBaseUrl={websiteBaseUrl}
            dataPath={dataPath}
          />
        )}
      </div>

      {children}
    </>
  );
};

export default LeagMainHead;
